export default {"src":"/_next/static/media/icon_unchecked_white.6c77244d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};